export const actionTypes = {
  LOGGED_USER_REQUEST: "LOGGED_USER_REQUEST",
  LOGGED_USER_SUCCESS: "LOGGED_USER_SUCCESS",
  LOGGED_USER_FAILURE: "LOGGED_USER_FAILURE",
  SET_TOKEN: "SET_TOKEN",
  CHANGE_LANGUAGE: "CHANGE_LANGUAGE",
  LOGOUT: "LOGOUT",
  TIME_EXPIRED: "TIME_EXPIRED",
  SET_TRIGGER_ERROR_MODAL: "SET_TRIGGER_ERROR_MODAL",
  SET_LANGUAGE_REQUEST: "SET_LANGUAGE_REQUEST",
  SET_LANGUAGE_REQUEST_SUCCESS: "SET_LANGUAGE_REQUEST_SUCCESS",
  SET_LANGUAGE_REQUEST_FAILURE: "SET_LANGUAGE_REQUEST_FAILURE",
  SET_FLOAT_SPINNER: "SET_FLOAT_SPINNER",

  SET_ACCESS_FROM_INTERNET: "SET_ACCESS_FROM_INTERNET",
};

export const loggedUserRequest = () => ({
  type: actionTypes.LOGGED_USER_REQUEST,
});

export const loggedUserSuccess = (payload: any) => ({
  type: actionTypes.LOGGED_USER_SUCCESS,
  payload,
});

export const loggedUserFailure = (err: any) => ({
  type: actionTypes.LOGGED_USER_FAILURE,
  err,
});

export const setToken = (payload: any) => ({
  type: actionTypes.SET_TOKEN,
  payload,
});

export const setAccessFromInternetAction = (payload: any) => ({
  type: actionTypes.SET_ACCESS_FROM_INTERNET,
  payload,
});

export const changeLanguage = (payload: any) => ({
  type: actionTypes.CHANGE_LANGUAGE,
  payload,
});

export const logout = () => ({
  type: actionTypes.LOGOUT,
});

export const timeExpired = (payload: any) => ({
  type: actionTypes.TIME_EXPIRED,
  payload,
});

export const setTriggerErrorModal = (payload: boolean) => ({
  type: actionTypes.SET_TRIGGER_ERROR_MODAL,
  payload,
});

export const setLanguageRequest = (payload: any) => ({
  type: actionTypes.SET_LANGUAGE_REQUEST,
  payload,
});

export const setLanguageRequestSuccess = (payload: any) => ({
  type: actionTypes.SET_LANGUAGE_REQUEST_SUCCESS,
  payload,
});

export const setLanguageRequestFailure = (payload: any) => ({
  type: actionTypes.SET_LANGUAGE_REQUEST_FAILURE,
  payload,
});

export const setFloatSpinner = (payload: boolean) => ({
  type: actionTypes.SET_FLOAT_SPINNER,
  payload,
});
